import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-use';
import BannerImg from '../../../../../public/assets/images/BannersFiles/31.jpg';
import { DataNotFound } from '../../../../components/DataNotFound';
import Loader from '../../../../components/Loader/Loader';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import PpCmsFilter from '../../../../components/elements/PpCmsFilter';
import StaticBanner from '../../../../components/elements/StaticBanner';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { defaultImage, monthNames } from '../../../../constants';
import { PageHitCountApi } from '../../../../shared/Helper';
import './infographic.scss';

export default function Infographic() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [date, setDate] = useState('');
  const [sortOrder, setSortOrder] = useState(0);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 6,
  });
  const [searchTitle, setSearchTitle] = useState('');

  const { t } = useTranslation();

  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const SearchFilter = {
    cmsTitle: searchTitle,
    dateFrom: moment(date).format('DD/MM/YYYY') ?? '',
    dateTo: moment(date).format('DD/MM/YYYY') || '',
  };

  const getData = async () => {

    setLoading(true);
    await postAsync(
      `CMSInfographic/GetUserInfographicSortFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
      SearchFilter,
    )
      .then((response) => {
        const result = response?.data;
        setLoading(false);
        setApiData(result);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    localStorage.setItem('isHome', true);
    getData();
  }, []);
  const fetchData = async () => {
    const newPage = pageOptions.pageNo + 1;
    try {
      setPageOptions((prev) => {
        return {
          ...prev,
          pageNo: prev.pageNo + 1,
        };
      });

      const response = await postAsync(
        `CMSInfographic/GetUserInfographicSortFilterList/${newPage}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      const newData = response?.data || [];
      setApiData((prevData) => [...prevData, ...newData]);
      setCurrentPage(response.currentPage);
    } catch (error) {
      console.error('Error fetching data:', error);
      setHasMore(false);
    }
  };

  const onSearch = async () => {
    try {
      setLoading(true);
      setDatanotfound(false);
      setPageOptions((pre) => {
        return {
          ...pre,
          pageNo: 1,
        };
      });
      const response = await postAsync(
        `CMSInfographic/GetUserInfographicSortFilterList/${1}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      if (response) {
        setLoading(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
    }
  };


  return (
    <>
      <div className="">
        <StaticBanner BannerImg={ BannerImg } en_US={ 'Info Graphic' } arabic={ false } />
        <section className={ `py-5` }>
          <div className="container justify-center ">
            <PpCmsFilter setSortOrder={ setSortOrder } date={ date } setDate={ setDate } getData={ onSearch } setSearchTitle={ setSearchTitle } />
            <div className="row justify-center">
              { !loading && apiData?.length > 0 && (
                <InfiniteScroll
                  className="row justify-center"
                  dataLength={ apiData?.length }
                  next={ currentPage === pageCount ? <></> : fetchData }
                  hasMore={ hasMore }
                  loader={
                    currentPage === pageCount ? (
                      <></>
                    ) : (
                      <div className="flex justify-center">
                        <Loader />
                      </div>
                    )
                  }
                >
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 grid-cols-1 grid-flow-row md:gap-14 gap-4 container">
                    { apiData?.map((data, index) => {
                      const splitdate = data?.date?.split('/');
                      var dates = `${splitdate[1]}/${splitdate[0]}/${splitdate[2]}`;

                      var date = new Date(dates);

                      var month = monthNames[date.getMonth()];

                      return (
                        // eslint-disable-next-line react/jsx-key
                        <div data-aos="zoom-in" data-aos-once="true">
                          <Link key={ index } to={ `/InfographicDetail/${data?.infographicID}` }>
                            {/* <div className="w-full  h-80 hover:scale-105 transition-transform duration-300 bg-white rounded-[50px] shadow-sm   shadow-gray-200">
                            <div className="flex flex-col items-center p-10">
                              <h5 className="mb-6 text-2xl font-bold "> { isActive ? data?.title : data?.titleEn } </h5>
                              <h5 className="mb-6 text-lg font-medium "> { data?.publicationDate } </h5>
                            </div>
                          </div> */}

                            <div className="hover:scale-105 transition-transform duration-300 max-w-sm bg-gray-100 my-2 rounded-3xl shadow-sm shadow-gray-200">
                              <div className="flex flex-col py-10 px-4  lg:pt-6 lg:py-10 lg:px-8">
                                <img
                                  src={ `data:image/jpeg;base64,${data?.doc ? data?.doc : defaultImage}` }
                                  className="rounded-t-3xl h-40 w-full"
                                />
                                <div className="h-20 w-20 mb-3 -mt-12 rounded-full shadow-md bg-customorange text-white text-center font-semibold flex flex-col items-center justify-center">
                                  {/* Placeholder for month */ }
                                  <p className="leading-tight text-xl">
                                    { splitdate[0] }
                                    <br />
                                  </p>
                                  <p className="text-sm">{ t(month) }</p>
                                </div>

                                <div>
                                  <h3 className="capitalize text-center w-full  text-customgreen lg:text-lg mb-1 font-semibold">
                                    { isActive
                                      ? data?.title.length > 15
                                        ? `${data?.title.slice(0, 15)}...`
                                        : data?.title
                                      : data?.titleEn.length > 15
                                        ? `${data.titleEn.slice(0, 15)}...`
                                        : data.titleEn }
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    }) }
                  </div>
                </InfiniteScroll>
              ) }
            </div>
          </div>
        </section>
        { loading && <LoadingAnimation /> }
        { datanotfound && <DataNotFound /> }
      </div>
    </>
  );
}
